import React from "react";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import SectionWrapper from "../components/SectionWrapper";
import { MISSION_MOTIFS } from "pages/createMission/utils/missionMotifs";

const Motif = () => {
    const { data } = UseContext();
    const { toggle } = useModal();

    return (
        <SectionWrapper 
            title="Motifs de recours" 
            description="Sélectionnez le motif de recours à l'intérim pour cette mission."
        >
            <div className={"flex flex-col gap-4"}>
                {MISSION_MOTIFS.map((item, index) => (
                    <div
                        key={index}
                        className={`ft-b text-gray-700 p-4 rounded-lg cursor-pointer ${
                            data.motif?.type === item.type
                                ? "border border-yellow-500 bg-yellow-50"
                                : "border border-gray-200"
                        }`}
                        onClick={(e) => {
                            toggle(item.modal);
                        }}
                    >
                        {item.title}
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
};

export default Motif;
